import { render } from "./AuthorBlocks.vue?vue&type=template&id=557f4692"
import script from "./AuthorBlocks.vue?vue&type=script&lang=js"
export * from "./AuthorBlocks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__